import ACTIONS from '../actions';

const subscribedTeamsTree = (state = [], action) => {
    switch (action.type) {
        case ACTIONS.SUBSCRIBED_TEAMS_LOAD:
            var newState = [...action.teams];
            newState.map(team => {
                team.key = team.id;
            });
            return newState;
        default:
            return state;
    }
};

export default subscribedTeamsTree;
